module.exports = __webpack_public_path__ + "img/ToolsIcon.85324bdf.svg";